var _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBots = function SvgBots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC5D",
    d: "M24 15v-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0M0 15v-4a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.25 2h1.5v3h-1.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.4,
    d: "M10.8 2.488V2.26a1.2 1.2 0 0 1 2.4 0v.228a1.2 1.2 0 0 1-2.4 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    d: "M10 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm6 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 14.5,
    x: 3.75,
    y: 5.75,
    stroke: "#000",
    strokeWidth: 1.5,
    rx: 2.25
  })));
};
export default SvgBots;